Updates an existing webhook subscription's delivery configuration.

This modifies fields related to the URL and payload of an existing webhook subscription.
Changes may take up to half an hour to take effect.

The fields that determine which events are to be delivered are immutable.
A new webhook subscription should be created for such cases.
